import { logError } from './log';

class ParseJSONError extends Error {
    constructor(message: string, error: SyntaxError, text: string) {
        super(message);
        this.name = 'ParseJSONError';

        // Append the text we were attempting to parse to the stack
        this.stack = `${error.stack}\nText: '${text}'`;
    }
}

export const parseJSON = (text: string, context: string): any => {
    try {
        return JSON.parse(text);
    } catch (syntaxError) {
        throw new ParseJSONError(`error parsing json: ${context}`, syntaxError, text);
    }
};
